import { useState } from 'react';
import { ExerciseExecutionMode } from '@guryou/core';

// const getOptions = providerId => {
//   if (+providerId === 289 || +providerId === 260) {
//     return [
//       { value: ExerciseExecutionMode.repetition, label: 'Repetition' },
//       { value: ExerciseExecutionMode.repetitionPerSide, label: 'Repetition Per Side' },
//       { value: ExerciseExecutionMode.repetitionMaximum, label: 'Repetition maximum' },
//       { value: ExerciseExecutionMode.pyramid, label: 'Pyramid' },
//       { value: ExerciseExecutionMode.duration, label: 'Duration' },
//       { value: ExerciseExecutionMode.durationPerSide, label: 'Duration Per Side' },
//       { value: ExerciseExecutionMode.distance, label: 'Distance' },
//       { value: ExerciseExecutionMode.laps, label: 'Laps' },
//     ];
//   }
//   return [
//     { value: ExerciseExecutionMode.repetition, label: 'Repetition' },
//     { value: ExerciseExecutionMode.repetitionPerSide, label: 'Repetition Per Side' },
//     { value: ExerciseExecutionMode.duration, label: 'Duration' },
//     { value: ExerciseExecutionMode.durationPerSide, label: 'Duration Per Side' },
//     { value: ExerciseExecutionMode.distance, label: 'Distance' },
//     { value: ExerciseExecutionMode.laps, label: 'Laps' },
//   ];
// };

const useExerciseMode = () => {
  const [values, setValues] = useState(null);

  const options = [
    { value: ExerciseExecutionMode.repetition, label: 'Repetition' },
    { value: ExerciseExecutionMode.repetitionPerSide, label: 'Repetition Per Side' },
    { value: ExerciseExecutionMode.repetitionMaximum, label: 'Repetition maximum' },
    { value: ExerciseExecutionMode.pyramid, label: 'Pyramid' },
    { value: ExerciseExecutionMode.duration, label: 'Duration' },
    { value: ExerciseExecutionMode.durationPerSide, label: 'Duration Per Side' },
    { value: ExerciseExecutionMode.distance, label: 'Distance' },
    { value: ExerciseExecutionMode.laps, label: 'Laps' },
  ];

  if (!values) {
    setValues(options);
  }

  return values;
};

export default useExerciseMode;
